import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { FeedPage } from "../feed";
import "./PersistentFeedLayout.css";

/**
 * PersistentFeedLayout - Twitter/Reddit Style Navigation
 * 
 * This layout ensures the feed NEVER unmounts when navigating to post details.
 * 
 * Architecture:
 * - FeedPage is ALWAYS rendered at full size
 * - When viewing post detail, feed is hidden via visibility:hidden
 * - PostDetailPage renders on TOP via Outlet
 * - Scroll position is preserved because feed dimensions don't change
 */
const PersistentFeedLayout = () => {
  const location = useLocation();
  
  // Check if we're viewing a post detail page
  const isPostDetailOpen = location.pathname.startsWith("/posts/");

  return (
    <div className="persistent-feed-layout">
      {/* PostDetailPage renders FIRST (on top via z-index) */}
      {isPostDetailOpen && (
        <div className="persistent-feed-layout__detail">
          <Outlet />
        </div>
      )}
      
      {/* Feed Container - ALWAYS MOUNTED at full size */}
      {/* visibility:hidden when post detail is open, but dimensions preserved */}
      <div
        className={`persistent-feed-layout__feed ${
          isPostDetailOpen ? "persistent-feed-layout__feed--hidden" : ""
        }`}
        aria-hidden={isPostDetailOpen}
      >
        <FeedPage />
      </div>
    </div>
  );
};

export default PersistentFeedLayout;
